import React, { useEffect, useState } from 'react';
import {
  get_sensor_list,
  sensor_configuration,
  update_sensor_status,
  update_delete_sensor,
  bp_units_data,
  add_sensor_type,
  get_sensor_type,
  get_machine_category,
} from '../../../utils/api';
import { toast } from 'react-toastify';
import {
  Input,
  Switch,
  Select,
  Popconfirm,
  Tooltip,
  Button,
  Row,
  Col,
  Space,
  Form,
  Card,
  Tag } from 'antd';
import { Formik } from 'formik';
import * as Yup from 'yup';
import ConfigModal from './ConfigModal';
import { accessControlUtils } from '@/components/AccessControlUtils';
import Icons from '@/components/third-party/Icons';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@/App';
import { defaultColors } from '@/themes/antd-theme';
import DataTable from '@/components/DataTable';
import PageHeader, { EmptyState } from '@/components/PageHeader';
import PageModal from '@/components/PageModal';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';
function SensorView() {
  const { t } = useTranslation();
  const { isDark } = useTheme();

  // Dark mode colors
  const textColor = isDark ? '#ffffff' : '#1f2937';

  const [sensorData, setsensorData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formEdit, setFormEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [typeList, setTypeList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [showTypeModal, setShowTypeModal] = useState(false);
  const [sensorTypeInput, setSensorTypeInput] = useState('');
  const [getStatus, setGetStatus] = useState(false);
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Sensor Name is required'),
    category_id: Yup.string().required('Category is required'),
    unit_id: Yup.string().required('Unit is required'),
    make: Yup.string().required('Make is required'),
    quantity: Yup.number().required('Quantity is required'),
    poll_rate: Yup.number().required('Poll Rate is required'),
    sensor_status: Yup.string().required('Status is required'),
    is_read: Yup.boolean().nullable(),
    is_write: Yup.boolean().nullable(),
  });

  const handleAdd = (values, resetForm) => {
    const req = {
      name: values.name,
      category_id: values.category_id,
      unit_id: values.unit_id,
      make: values.make,
      sensor_status: values.sensor_status === 'Active',
      ip_address: values.ip_address || '',
      port: values.port || '',
      type: values.type_id || '',
      address: values.address || '',
      poll_rate: values.poll_rate || '',
      quantity: values.quantity || '',
      is_read: values.is_read || false,
      is_write: values.is_write || false,
    };

    if (formEdit) {
      update_delete_sensor({ ...req, update: true, id: editId }, successUpdateDelete);
    } else {
      sensor_configuration(req, successAdd);
    }
  };

  const successAdd = (res) => {
    if (res?.status === 'success') {
      toast.success(res?.message);
      get_all_sensor();
      handleCloseForm();
    } else {
      toast.warning(res?.message);
    }
  };

  const successUpdateDelete = (res) => {
    if (res?.status === 'success') {
      toast.success(res?.message);
      get_all_sensor();
      handleCloseForm();
    } else {
      toast.warning(res?.message);
    }
  };

  const handleEdit = (record) => {
    setFormEdit(true);
    setShowForm(true);
    setEditId(record?.sensor_id);
    // pass values to Formik via enableReinitialize
    setInitialValues({
      name: record.sensor_name,
      ip_address: record.ip_address,
      port: record.port,
      type_id: record.type_id,
      category_id: record.category_id,
      unit_id: record.unit_id,
      make: record.make,
      address: record.address,
      quantity: record.quantity,
      poll_rate: record.poll_rate,
      sensor_status: record.status ? 'Active' : 'InActive',
      is_read: record.is_read || false,
      is_write: record.is_write || false,
    });
  };

  const defaultFormValues = {
    name: '',
    ip_address: '',
    port: '',
    type_id: '',
    category_id: '',
    unit_id: '',
    make: '',
    address: '',
    quantity: '',
    poll_rate: '',
    sensor_status: '',
    is_read: true,
    is_write: false,
  };

  const [initialValues, setInitialValues] = useState(defaultFormValues);

  const handleCloseForm = () => {
    setShowForm(false);
    setFormEdit(false);
    setEditId(null);
    setInitialValues(defaultFormValues);
  };

  const onChangeStatus = (checked, record) => {
    update_sensor_status({ sensor_id: record.sensor_id, sensor_status: checked }, (res) => {
      if (res.status === 'success') {
        toast.success(res.message);
        get_all_sensor();
      } else toast.warning(res.message);
    });
  };

  const [loading, setLoading] = useState(false);
  const get_all_sensor = async () => {
    setLoading(true);
    try {
      await get_sensor_list((res) => { setsensorData(res?.data?.data || []); setLoading(false); });
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data?.message || 'Failed to load sensors');
      setLoading(false);
    }
  };

  const get_all_dropdown = async () => {
    try {
      await bp_units_data((res) => setUnitList(res?.data?.data || []));
      await get_sensor_type((res) => setTypeList(res?.data?.data || []));
      await get_machine_category((res) => setCategoryList(res?.data?.data || []));
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    get_all_sensor();
    get_all_dropdown();
  }, []);

  const dash = (v) => (v === null || v === undefined || v === '' ? '—' : v);
  const allColumns = [
    { title: 'Sensor Name', dataIndex: 'sensor_name', key: 'sensor_name', width: 260, defaultVisible: true, sortType: 'string', render: (v) => <span className="font-medium">{dash(v)}</span> },
    { title: 'Category', dataIndex: 'category', key: 'category', width: 170, defaultVisible: true, sortType: 'string', render: dash },
    { title: 'IP', dataIndex: 'ip_address', key: 'ip', width: 140, defaultVisible: true, sortType: 'string', render: dash },
    { title: 'Type', dataIndex: 'type', key: 'type', width: 120, defaultVisible: true, sortType: 'string', render: dash },
    { title: 'Address', dataIndex: 'address', key: 'address', width: 130, defaultVisible: true, sortType: 'string', render: dash },
    { title: 'Poll Rate', dataIndex: 'poll_rate', key: 'poll_rate', width: 110, align: 'right', defaultVisible: true, sortType: 'number', render: dash },
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity', width: 110, align: 'right', defaultVisible: true, sortType: 'number', render: dash },
    { title: 'Unit', dataIndex: 'unit', key: 'unit', width: 90, defaultVisible: true, sortType: 'string', render: dash },
    { title: 'Make', dataIndex: 'make', key: 'make', width: 150, defaultVisible: true, sortType: 'string', render: dash },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      align: 'center',
      defaultVisible: true,
      sortType: 'boolean',
      render: (val, rec) => (
        <Tooltip title={val ? 'InActive' : 'Active'}>
          <Switch
            checked={val}
            disabled={!accessControlUtils('Plant & Equipment')?.create_access}
            onChange={(checked) => onChangeStatus(checked, rec)}
          />
        </Tooltip>
      ),
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      width: 190,
      align: 'center',
      defaultVisible: true,
      alwaysVisible: true,
      render: (_, record) => (
        <Space>
          <Button
            size="small"
            aria-label={`Edit ${record.sensor_name}`}
            icon={<Icons.Pencil className="w-3.5 h-3.5 text-amber-600" />}
            onClick={() => handleEdit(record)}
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this sensor?"
            onConfirm={() => update_delete_sensor({ id: record.sensor_id }, successUpdateDelete)}
            okText="Yes"
            cancelText="No"
          >
            <Button size="small" danger aria-label={`Delete ${record.sensor_name}`} icon={<Icons.Trash2 className="w-3.5 h-3.5" />}>
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div
      className="p-2.5 pt-5"
      style={{ backgroundColor: isDark ? defaultColors.palette.gray[900] : '#f9fafb' }}
    >
      <Card
        className="border border-gray-300 shadow-md"
        bordered={false}
        classNames={{ body: 'page-card-scroll' }}
        style={{ backgroundColor: isDark ? defaultColors.palette.gray[800] : '#ffffff', height: 'calc(100dvh - 120px)', display: 'flex', flexDirection: 'column' }}
        styles={{ body: { flex: 1, minHeight: 0, overflowY: 'auto', padding: '12px 16px' } }}
        title={
          <PageHeader
            compact
            icon={<Icons.Activity size={22} />}
            title={t('Sensor')}
            description="Sensors with category, unit, polling rate and connection details."
            extra={
              accessControlUtils('Plant & Equipment')?.create_access ? (
                showForm ? (
                  <Button icon={<CloseOutlined />} onClick={handleCloseForm}>Close form</Button>
                ) : (
                  <Button type="primary" icon={<PlusOutlined />} onClick={() => setShowForm(true)}>Add Sensor</Button>
                )
              ) : null
            }
          />
        }
      >
        {showForm && (
          <div
            className="rounded-xl border mb-5"
            style={{
              backgroundColor: isDark ? defaultColors.palette.gray[700] : '#f9fafb',
              borderColor: isDark ? defaultColors.palette.gray[600] : '#e5e7eb',
              borderLeftColor: formEdit ? '#f59e0b' : defaultColors.primary,
              borderLeftWidth: 4,
              borderLeftStyle: 'solid',
              padding: '20px 24px 12px',
            }}
          >
            <div className="flex items-center gap-2 mb-4">
              <div
                className="p-1.5 rounded-md"
                style={{
                  backgroundColor: formEdit
                    ? isDark
                      ? 'rgba(245,158,11,0.08)'
                      : '#fffbeb'
                    : isDark
                    ? defaultColors.palette.teal[900]
                    : defaultColors.palette.teal[50],
                }}
              >
                {formEdit ? (
                  <Icons.Pencil className="w-4 h-4" style={{ color: '#f59e0b' }} />
                ) : (
                  <Icons.Plus className="w-4 h-4" style={{ color: defaultColors.primary }} />
                )}
              </div>
              <span
                className="text-sm font-semibold"
                style={{ color: formEdit ? '#f59e0b' : defaultColors.primary }}
              >
                {formEdit ? 'Edit Sensor' : 'Add New Sensor'}
              </span>
              {formEdit && (
                <Tag color="warning" className="ml-2 text-xs">
                  Editing
                </Tag>
              )}
            </div>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={(values, { resetForm }) => handleAdd(values, resetForm)}
            >
              {({
                values,
                handleChange,
                handleSubmit,
                setFieldValue,
                errors,
                touched,
                handleReset,
              }) => (
                <Form layout="vertical" onFinish={handleSubmit}>
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            Sensor Name
                          </span>
                        }
                        validateStatus={touched.name && errors.name ? 'error' : ''}
                        help={touched.name && errors.name ? errors.name : ''}
                      >
                        <Input
                          name="name"
                          value={values.name}
                          onChange={handleChange}
                          placeholder="Enter sensor name"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            IP Address
                          </span>
                        }
                      >
                        <Input
                          name="ip_address"
                          value={values.ip_address}
                          onChange={handleChange}
                          placeholder="Enter IP"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            Port
                          </span>
                        }
                      >
                        <Input
                          name="port"
                          value={values.port}
                          onChange={handleChange}
                          placeholder="Enter Port"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            Type
                          </span>
                        }
                      >
                        <Space.Compact style={{ width: '100%' }}>
                          <Select
                            allowClear
                            showSearch
                            placeholder="Select Type"
                            value={values.type_id}
                            onChange={(val) => setFieldValue('type_id', val)}
                            options={typeList.map((i) => ({
                              label: i.name,
                              value: i.id,
                            }))}
                            style={{ width: '100%' }}
                          />
                          <Button
                            icon={<Icons.Plus className="w-4 h-4" />}
                            onClick={() => setShowTypeModal(true)}
                          >
                            New type
                          </Button>
                        </Space.Compact>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            Category
                          </span>
                        }
                        validateStatus={touched.category_id && errors.category_id ? 'error' : ''}
                        help={touched.category_id && errors.category_id ? errors.category_id : ''}
                      >
                        <Select
                          allowClear
                          showSearch
                          placeholder="Select Category"
                          value={values.category_id}
                          onChange={(val) => setFieldValue('category_id', val)}
                          options={categoryList.map((i) => ({
                            label: i.category,
                            value: i.category_id,
                          }))}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            Make
                          </span>
                        }
                        validateStatus={touched.make && errors.make ? 'error' : ''}
                        help={touched.make && errors.make ? errors.make : ''}
                      >
                        <Input
                          name="make"
                          value={values.make}
                          onChange={handleChange}
                          placeholder="Enter Manufacturer"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            Address
                          </span>
                        }
                      >
                        <Input
                          name="address"
                          value={values.address}
                          onChange={handleChange}
                          placeholder="Enter Address"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            Quantity
                          </span>
                        }
                        validateStatus={touched.quantity && errors.quantity ? 'error' : ''}
                        help={touched.quantity && errors.quantity ? errors.quantity : ''}
                      >
                        <Input
                          name="quantity"
                          value={values.quantity}
                          onChange={handleChange}
                          placeholder="Enter Quantity"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            Unit
                          </span>
                        }
                        validateStatus={touched.unit_id && errors.unit_id ? 'error' : ''}
                        help={touched.unit_id && errors.unit_id ? errors.unit_id : ''}
                      >
                        <Space.Compact style={{ width: '100%' }}>
                          <Select
                            allowClear
                            showSearch
                            placeholder="Select Unit"
                            value={values.unit_id}
                            onChange={(val) => setFieldValue('unit_id', val)}
                            options={unitList.map((i) => ({
                              label: i.unit_name,
                              value: i.id,
                            }))}
                          />
                          <Button
                            icon={<Icons.Plus className="w-4 h-4" />}
                            onClick={() => setShowModal(true)}
                          >
                            New unit
                          </Button>
                        </Space.Compact>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            Poll Rate
                          </span>
                        }
                        validateStatus={touched.poll_rate && errors.poll_rate ? 'error' : ''}
                        help={touched.poll_rate && errors.poll_rate ? errors.poll_rate : ''}
                      >
                        <Input
                          name="poll_rate"
                          value={values.poll_rate}
                          onChange={handleChange}
                          placeholder="Enter Poll Rate"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            Status
                          </span>
                        }
                        validateStatus={
                          touched.sensor_status && errors.sensor_status ? 'error' : ''
                        }
                        help={
                          touched.sensor_status && errors.sensor_status ? errors.sensor_status : ''
                        }
                      >
                        <Select
                          allowClear
                          placeholder="Select Status"
                          value={values.sensor_status}
                          onChange={(val) => setFieldValue('sensor_status', val)}
                          options={[
                            { label: 'Active', value: 'Active' },
                            { label: 'InActive', value: 'InActive' },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            Read Access
                          </span>
                        }
                      >
                        <Switch
                          checked={values.is_read}
                          onChange={(checked) => setFieldValue('is_read', checked)}
                          checkedChildren="Yes"
                          unCheckedChildren="No"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label={
                          <span className="font-medium" style={{ color: textColor }}>
                            Write Access
                          </span>
                        }
                      >
                        <Switch
                          checked={values.is_write}
                          onChange={(checked) => setFieldValue('is_write', checked)}
                          checkedChildren="Yes"
                          unCheckedChildren="No"
                        />
                      </Form.Item>
                    </Col>
                    <Col span={24} className="flex justify-end gap-2 mt-2">
                      <Button
                        onClick={() => {
                          handleReset();
                          handleCloseForm();
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                        icon={
                          formEdit ? (
                            <Icons.Check className="w-4 h-4" />
                          ) : (
                            <Icons.Plus className="w-4 h-4" />
                          )
                        }
                        style={
                          formEdit ? { backgroundColor: '#f59e0b', borderColor: '#f59e0b' } : {}
                        }
                      >
                        {formEdit ? 'Update' : 'Add'}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </div>
        )}
        <DataTable
          className="sensor-config-table"
          tableKey="sensor_config"
          searchable
          columnConfig
          showCount={false}
          data={sensorData}
          columns={allColumns}
          rowKey="sensor_id"
          bordered
          scrollX="max-content"
          height={null}
          loading={loading}
          exportable
          exportFilename="sensors"
          locale={{ emptyText: <EmptyState title="No sensors yet" description="Add your first sensor to get started." actionLabel="Add Sensor" onAction={() => setShowForm(true)} /> }}
        />
        <ConfigModal
          show_modal={showModal}
          set_show_modal={setShowModal}
          add_number={2}
          get_status={getStatus}
          set_get_status={setGetStatus}
        />
        <PageModal
          open={showTypeModal}
          icon={<Icons.Activity size={22} />}
          title="Add Sensor Type"
          description="A new type to pick on sensors."
          width={480}
          destroyOnHidden
          onCancel={() => setShowTypeModal(false)}
          footer={
            <div className="flex justify-end gap-2">
              <Button onClick={() => setShowTypeModal(false)}>Cancel</Button>
              <Button
                type="primary"
                disabled={!sensorTypeInput}
                onClick={() => {
                  add_sensor_type({ name: sensorTypeInput }, () => {
                    setShowTypeModal(false);
                    setSensorTypeInput('');
                    get_all_dropdown();
                  });
                }}
              >
                Add
              </Button>
            </div>
          }
        >
          <div className="flex flex-col gap-1">
            <span className="font-medium">Type</span>
            <Input
              placeholder="Enter Type"
              value={sensorTypeInput}
              onChange={(e) => setSensorTypeInput(e.target.value)}
            />
          </div>
        </PageModal>
      </Card>
    </div>
  );
}

export default SensorView;
